import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]
  
  show() {
    if (!this.hasTooltipTarget) return
    
    // Position tooltip inside the card, below the price badge
    const rect = this.element.getBoundingClientRect()
    const tooltipRect = this.tooltipTarget.getBoundingClientRect()
    
    // Calculate position - position it below the price badge, inside the tile
    const left = rect.width / 2 - tooltipRect.width / 2
    const top = rect.height + 8 // Below the price badge
    
    this.tooltipTarget.style.left = `${left}px`
    this.tooltipTarget.style.top = `${top}px`
    
    // Show tooltip
    this.tooltipTarget.classList.remove("opacity-0")
    this.tooltipTarget.classList.add("opacity-100")
  }
  
  hide() {
    if (!this.hasTooltipTarget) return
    
    this.tooltipTarget.classList.remove("opacity-100")
    this.tooltipTarget.classList.add("opacity-0")
  }
}